import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js'

export default class ShippingMeansSelector extends HTMLDivElement {
    connectedCallback() {
        this.inputs = [...this.querySelectorAll('input[name="delivery-mode"]')];
        this.mainContainer = document.getElementById('main-container');

        this.initEvents();
    }

    /**
     * Écouteurs d'événements.
     */
    initEvents() {
        // Changement de sélection
        this.inputs.forEach((item) => {
            item.addEventListener('change', (e) => {
                if (e.target.checked) {
                    this.updateDeliveryMode(e.target.value);
                }
            });
        })
    }

    /**
     * Met à jour le panier avec le mode de livraison sélectionné.
     */
    updateDeliveryMode(value) {
        const requestor = new Requestor();
        requestor.sendRequest( this.dataset.route, 'PUT', {
            'shipping_means' : value,
            'update-cart' : true,
            'return_templates' : ['transformation.transformation-prices'],
        }, (data) => {
            this.mainContainer.updateCartViews(data);
        });
    }
};

